import {
  Badge,
  Button,
  Col,
  Drawer,
  Dropdown,
  Row,
  Popover,
  Alert,
  Typography,
  Avatar,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaShoppingBag } from "react-icons/fa";
import { useEffect, useState } from "react";
import { IoMenu } from "react-icons/io5";
import { ImageUrl } from "../../config/helper";
import { useSelector } from "react-redux";
import { GoBellFill } from "react-icons/go";
import { AiFillCaretDown, AiFillApple } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { removeUser } from "../../redux/slice/authSlice";
import { clearCart } from "../../redux/slice/cartSlice";
// import avatar from "../../assets/images/avatar.png";
import {
  NOTIFICATIONS,
  PROFILE,
  UPLOADS_URL,
} from "../../config/constants/api";
import { Get } from "../../config/api/get";
import socket from "../../config/socket/index.js";
import { setCount } from "../../redux/slice/notificationSlice";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const user = useSelector((state) => state.user.userData);
  const cart = useSelector((state) => state.cart.cartItems);
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const notificationsCount = useSelector((state) => state.notification.count);
  const [logoutModal, setLogoutModal] = useState(false);
  const cartCount = cart?.length;
  const handleLogout = () => {
    setLogoutModal(false);
    dispatch(removeUser());
    navigate("/signin");
  };
  const [latestNotifications, setLatestNotifications] = useState(null);
  useEffect(() => {
    getAllNotifications();
  }, []);

  useEffect(() => {
    socket.on("notification", (data) => {
      getAllNotifications();
    });
    return () => {
      socket.off("notification");
    };
  }, []);
  useEffect(() => {
    socket.on("bookingAccepted", (data) => {
      getAllNotifications();
    });
    return () => {
      socket.off("bookingAccepted");
    };
  }, []);
  const getAllNotifications = () => {
    Get(NOTIFICATIONS.getAllMyNotifications, token, {
      page: "1",
      limit: "3",
      isRead: false,
    })
      .then((response) => {
        if (response?.status) {
          setLatestNotifications(response?.data?.notifications?.docs);
          dispatch(setCount(response?.data?.unreadCount));
        }
      })
      .catch((err) => {
        console.log("Error fetching notifications ", err);
      });
  };
  useEffect(() => {
    // Extract the pathname from the location object
    const currentPath = location.pathname;

    // Set the activeTab state based on the current path
    if (currentPath === "/") {
      setActiveTab("HOME");
    } else if (currentPath === "/chauffeurBookingLogs") {
      setActiveTab("DASHBOARD");
    } else if (currentPath === "/about") {
      setActiveTab("ABOUT");
    } else if (currentPath === "/services") {
      setActiveTab("SERVICES");
    } else if (currentPath === "/ourModals") {
      setActiveTab("OURMODALS");
    } else if (currentPath === "/Blogs") {
      setActiveTab("BLOGS");
    } else if (currentPath === "/contact") {
      setActiveTab("CONTACT");
    } else {
      setActiveTab(""); // If none of the above, reset activeTab
    }
  }, [location.pathname]);
  const items = [
    {
      key: "1",
      label: (
        <Link to="/profile" className="px-8 font-euclid text-sm font-semibold">
          My Profile
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          style={{}}
          className="px-8 font-euclid text-sm font-semibold"
          onClick={handleLogout}
        >
          Logout
        </div>
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const isHomepage = location.pathname === "/";
  const onLinkClick = (path) => {
    onClose(); // Close the drawer
    navigate(path); // Navigate to the desired path
  };

  const content = (
    <div style={{ width: "350px" }}>
      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Notifications</h3>
        <Alert
          message={`${notificationsCount} New`}
          type="success"
          style={{ fontSize: "12px", padding: "2px 10px", color: "green" }}
        />
      </div>
      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />
      <div style={{ height: "250px", overflow: "auto" }}>
        {latestNotifications &&
          latestNotifications.length > 0 &&
          latestNotifications.map((item) => {
            return (
              <div
                style={{
                  padding: 10,
                  minHeight: "100px",
                  borderBottom: "1px solid #dadada",
                  marginBottom: "5px",
                }}
              >
                <Row
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Col xs={4}>
                    <div
                      style={{
                        // padding: "10px 10px 10px 10px",
                        display: "flex",
                        width: "40px",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "40px",
                        backgroundColor: "#ffb600",
                        borderRadius: "5px",
                      }}
                    >
                      <GoBellFill
                        style={{ fontSize: "20px", color: "white" }}
                      />
                    </div>
                  </Col>
                  <Col xs={18}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{ fontSize: "14px", color: "black", margin: 0 }}
                    >
                      {item?.title}
                    </Typography.Title>

                    <Typography.Text
                      className="fontFamily1"
                      style={{ fontSize: "12px", color: "black", margin: 0 }}
                    >
                      {item?.content?.slice(0, 100)}{" "}
                      {item?.content.length > 100 && "..."}
                    </Typography.Text>
                  </Col>
                </Row>
              </div>
            );
          })}
      </div>

      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />

      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button onClick={() => navigate("/notifications")} type="link">
          View All
        </Button>
      </div>
    </div>
  );

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClick = () => {
    if (location.pathname === "/") {
      scrollToSection("members-section");
    } else {
      console.log("check");
      navigate("/");
      setTimeout(() => scrollToSection("members-section"), 100);
    }
  };
  let imageUrl = UPLOADS_URL + userData?.image 

  return (
    <Row
      justify="center"
      className={`bg-none z-10 w-full py-4 ${isHomepage ? "absolute" : ""}`}
      // style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <Col lg={20} md={21} sm={22} xs={22}>
        <Row justify="center">
          <Col md={4} sm={4} xs={4} className="self-center">
            <img
              src={ImageUrl("logo.png")}
              alt="logo"
              className="cursor-pointer"
              onClick={() => navigate("/")}
            />
          </Col>
          <Col lg={0} md={16} sm={18} xs={18}></Col>
          <Col lg={16} md={0} sm={0} xs={0} className="self-center">
            <Row justify="center" className="py-8">
              <div className="flex justify-center items-center">
                <Link
                  to="/"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "HOME" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                >
                  Home
                </Link>
                {token && (
                  <Link
                    to="/chauffeurBookingLogs"
                    className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                      activeTab === "DASHBOARD"
                        ? "text-customGold"
                        : "text-white"
                    } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                  >
                    Dashboard
                  </Link>
                )}
                <Link
                  to="/about"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "ABOUT" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                >
                  About Us
                </Link>
                <Link
                  to="/services"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "SERVICES" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                >
                  Our Services
                </Link>
                {/* <Link
                  to="/signIn"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Our Services
                </Link> */}
                <Link>
                {/* <p
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4"
                  onClick={handleClick}
                >
                  Memberships
                </p> */}
                </Link>
                <Link
                  to="/membership"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "MEMBERSHIP" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                  // className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                 Memberships
                </Link>
                <Link
                  to="/ourModals"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "OURMODALS" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                  // className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Our Models
                </Link>
                <Link
                  to="/Blogs"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "BLOGS" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                >
                  Blogs
                </Link>
                <Link
                  to="/contact"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "CONTACT" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-3 max-desktop:px-4 max-lg:px-4`}
                  // className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Contact Us
                </Link>
                {/* <Dropdown
                  menu={{
                    items,
                  }}
                  placement="bottom"
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                      activeTab === "ABOUT" ? "text-customGold" : "text-white"
                    } max-2xl:text-sm text-end flex px-8 max-desktop:px-6 max-lg:px-4`}
                  >
                    ABOUT
                    <FaChevronDown className="ml-1 mt-1" />
                  </a>
                </Dropdown> */}
              </div>
            </Row>
          </Col>
          <Col md={4} sm={2} xs={2} className="self-center">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              className="header-find-box"
            >
              {!token ? (
                <>
                  <div className="flex justify-end items-center">
                    <button
                      className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs mx-4 max-lg:hidden"
                      onClick={() => navigate("/signIn")}
                    >
                      sign in
                    </button>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "right",
                    gap: "5%",
                  }}
                  className="header-btn-container"
                >
                  <Popover
                    content={content}
                    placement="bottomRight"
                    arrow={false}
                    className="headerPopover"
                  >
                    <Badge
                      count={notificationsCount}
                      style={{
                        backgroundColor: "red",
                        padding: "0",
                        minWidth: "15px",
                        height: "15px",
                        fontSize: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <GoBellFill style={{ fontSize: "25px", color: "#fff" }} />
                    </Badge>
                  </Popover>
                  &emsp;
                  {!userData?.isGuest ? (
                    <div
                      style={{
                        minWidth: "120px",
                        display: "flex",
                        alignItems: "center",
                        cursor:'pointer'
                      }}
                    >
                      <img
                        src={(!imageUrl || imageUrl.includes('null')) ? ImageUrl('avatar.png') : imageUrl}
                        className="h-[50px] w-[50px] max-sm:h-[40px] max-sm:w-[40px] rounded-full object-cover object-center"
                        alt="vector"
                      />

                      <Dropdown
                        menu={{
                          items,
                        }}
                        trigger={["click"]}
                        placement="bottomRight"
                      >
                        <p
                          style={{
                            marginLeft: 10,
                            fontSize: "16px",
                            textTransform: "capitalize",
                            color: "#fff",
                          }}
                          className="font-euclid"
                        >
                          {user?.firstName} <AiFillCaretDown fontSize={12} />{" "}
                        </p>
                      </Dropdown>
                    </div>
                  ) : (
                    <div
                      style={{
                        minWidth: "120px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        onClick={handleLogout}
                        className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-10 h-[40px] hover:text-customGold text-center text-sm"
                      >
                        Logout
                      </Button>
                    </div>
                  )}
                </div>
              )}
              <div onClick={showDrawer} className="lg:hidden">
                <IoMenu size={36} className="text-white" />
              </div>
            </div>
            {/* {!token && (
              <div className="flex justify-end items-center">
                <button
                  className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs mx-4 max-lg:hidden"
                  onClick={() => navigate("/signIn")}
                >
                  sign in
                </button>
                <div onClick={showDrawer} className="lg:hidden">
                  <IoMenu size={36} className="text-white" />
                </div>
              </div>
            )} */}
          </Col>
          <Drawer title="Menu" onClose={onClose} open={open}>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              <Link onClick={() => onLinkClick("/")} to="/">
                HOME
              </Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              {token && (
                <Link
                  onClick={() => onLinkClick("/chauffeurBookingLogs")}
                  to="/chauffeurBookingLogs"
                >
                  Dashboard
                </Link>
              )}
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              <Link onClick={() => onLinkClick("/about")} to="/about">
                About Us
              </Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              <Link onClick={() => onLinkClick("/memberships")} to="/">
                Memberships
              </Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              <Link onClick={() => onLinkClick("/ourModals")} to="/ourModals">
                Our Models
              </Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              <Link onClick={() => onLinkClick("/contact")} to="/contact">
                Contact Us
              </Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4">
              {!token && (
                <button
                  className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs"
                  onClick={() => navigate("/signIn")}
                >
                  sign in
                </button>
              )}
            </div>
          </Drawer>
          {/* <Drawer title="Menu" onClose={onClose} open={open}>
            <div
              to="/"
              className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4"
            >
              <Link to="/">HOME</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
            {token && (
              <Link to="/chauffeurBookingLogs">Dashboard</Link>
            )}
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link to="/about">About Us</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link  onClick={handleClick}>Memberships</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link to="/ourModals">Our Models</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link to="/contact">Contact Us</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link to="/register">REGISTER</Link>
            </div>
            <div className="text-xl font-euclid cursor-pointer text-customGold hover:text-customBlack mb-4 ">
              <Link to="/signIn">SIGN IN</Link>
            </div>
          </Drawer> */}
        </Row>
      </Col>
    </Row>
  );
};

export default Header;
